angular.module('surfsightApp.controllers').controller('ResetPasswordCtrl', [
  '$scope',
  '$rootScope',
  '$log',
  '$state',
  '$stateParams',
  '$timeout',
  '$location',
  '$http',
  '$filter',
  '$mdDialog',
  '$mdSidenav',
  '$mdToast',
  '$mdColors',
  '$localStorage',
  function (
    $scope,
    $rootScope,
    $log,
    $state,
    $stateParams,
    $timeout,
    $location,
    $http,
    $filter,
    $mdDialog,
    $mdSidenav,
    $mdToast,
    $mdColors,
    $localStorage
  ) {
    var ec = this
    var $translate = $filter('translate')
    $scope.data.whitelabel = $rootScope.data.whitelabel
    $rootScope.$on('whitelabelConfig', (event, data) => {
      $scope.data.whitelabel = $rootScope.data.whitelabel
    })
    $scope.themePrimary = $mdColors.getThemeColor('primary')
    $scope.resetPassword_data = {}
    $scope.checkMatchingpassword = function (form) {
      // ~ console.log(form.password2.$modelValue);
      if (form.password1.$modelValue && form.password2.$modelValue) {
        if (form.password1.$modelValue != form.password2.$modelValue) {
          form.password2.$setValidity('retypeMismatch', false)
          return true
        } else {
          form.password2.$setValidity('retypeMismatch', true)
        }
      }
      return false
    }
    $scope.resetPassword = function (resetpasswordForm) {
      if ($scope.checkMatchingpassword(resetpasswordForm)) {
        return false
      }
      var request_json = {
        method: 'POST',
        url: USER_BASEURL + '/resetpassword/' + $stateParams.token,
        data: $scope.resetPassword_data
      }
      $http(request_json).then(
        function (response) {
          if (response.data.status.code == 0) {
            delete $localStorage.userToken
            $scope.showMessageToast($translate(response.data.status.error))
            setTimeout(function () {
              $state.go('home.login')
            })
          } else {
            alert(response.data.status.message)
          }
        },
        function (response) {
          alert('Error occurred. Please try again.')
        }
      )
    }
    $scope.showMessageToast = function (message) {
      var toast = $mdToast
        .simple()
        .textContent(message)
        .action($translate('ok'))
        .actionKey('F1')
        .position('top right')
        .hideDelay(5000)

      $mdToast
        .show(toast)
        .then(function (response) {})
        .catch(() => {})
    }
  }
])
